import { H2, Large, Small } from '@/components/sv/typographies'
import { Separator } from '@/components/ui/separator'
import { cn } from '@/lib/utils'

type Props = {
  variant?: 'default' | 'glass'
  forceAlign?: 'start' | 'center'
  showTitle?: boolean
  balance: number
  expiresAt: string | null
  hasCreditExpiry: boolean
}

export const CreditAndExpiryDisplay = ({
  variant = 'default',
  forceAlign = 'center',
  showTitle = true,
  balance,
  expiresAt,
  hasCreditExpiry,
}: Props) => {
  return (
    <>
      {showTitle ? (
        <H2
          className={cn('text-md', {
            'text-white': variant === 'glass',
          })}
        >
          Your credits
        </H2>
      ) : null}
      <div
        className={cn('w-full flex xl:justify-center items-center gap-8', {
          'mt-4 xl:mt-6': variant === 'glass' && showTitle,
          'mt-2': variant === 'default' && showTitle,
          'justify-center!': hasCreditExpiry && forceAlign !== 'start',
          'justify-start!': !hasCreditExpiry || forceAlign === 'start',
        })}
      >
        <div className="flex flex-col gap-2">
          <Large
            className={cn('text-3xl', {
              'xl:text-center': hasCreditExpiry,
              'text-white': variant === 'glass',
            })}
          >
            ${balance}
          </Large>
          <Small
            className={cn('text-muted-foreground xl:text-center', {
              'text-white/90': variant === 'glass',
            })}
          >
            available credits
          </Small>
        </div>
        {hasCreditExpiry ? (
          <>
            <Separator
              orientation="vertical"
              className={cn('h-[40px]!', {
                'bg-white/30': variant === 'glass',
              })}
            />
            <div className="flex flex-col gap-2">
              <Large
                className={cn('text-3xl xl:text-center', {
                  'text-white': variant === 'glass',
                })}
              >
                {expiresAt}
              </Large>
              <Small
                className={cn('xl:text-center text-muted-foreground', {
                  'text-white/90': variant === 'glass',
                })}
              >
                until credit expiry
              </Small>
            </div>
          </>
        ) : null}
      </div>
    </>
  )
}
